export const ZOOMED_IN_EARTH_COST = 25;
export const EARTH_RIDDLE_MACHINE_COST = 100;

export const EARTH_MODE_IMPOSSIBLE = 'earth_impossible';
export const EARTH_MODE_IMPOSSIBLE_ISH = 'earth_impossible_ish';

export const EARTH_MODES = Object.freeze([
  {
    key: EARTH_MODE_IMPOSSIBLE,
    label: 'Impossible',
    subtitle: 'One shot only',
  },
  {
    key: EARTH_MODE_IMPOSSIBLE_ISH,
    label: 'Impossible-ish',
    subtitle: 'Three guesses with reveals',
  },
]);

export const EARTH_MAX_ATTEMPTS_BY_MODE = Object.freeze({
  [EARTH_MODE_IMPOSSIBLE]: 1,
  [EARTH_MODE_IMPOSSIBLE_ISH]: 3,
});

// These values control the image box size (%) used for local zoom reveals.
// Higher value = tighter crop.
export const EARTH_REVEAL_ZOOM_LEVELS_BY_MODE = Object.freeze({
  // Impossible now auto fully zooms out after the one guess resolves.
  [EARTH_MODE_IMPOSSIBLE]: [1300, 100],
  [EARTH_MODE_IMPOSSIBLE_ISH]: [1300, 650, 225],
});

// A guess is considered "correct enough" if it lands within this radius.
export const EARTH_CORRECT_DISTANCE_KM = 75;

// Accuracy is a user-facing signal for how close the guess was.
// We use an exponential decay so close guesses feel meaningfully better.
export const EARTH_ACCURACY_DECAY_KM = 2500;

// UI guardrails.
export const EARTH_DEFAULT_MAP_CENTER = Object.freeze({ lat: 20, lng: 0 });
export const EARTH_DEFAULT_MAP_ZOOM = 2;
export const EARTH_MIN_MAP_ZOOM = 1;
export const EARTH_MAX_MAP_ZOOM = 5;

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export const getEarthMaxAttempts = (mode) =>
  EARTH_MAX_ATTEMPTS_BY_MODE[mode] ?? EARTH_MAX_ATTEMPTS_BY_MODE[EARTH_MODE_IMPOSSIBLE_ISH];

export const getEarthZoomLevels = (mode) =>
  EARTH_REVEAL_ZOOM_LEVELS_BY_MODE[mode] ??
  EARTH_REVEAL_ZOOM_LEVELS_BY_MODE[EARTH_MODE_IMPOSSIBLE_ISH];

export const getEarthZoomLevelForMissCount = (mode, missCount) => {
  const levels = getEarthZoomLevels(mode);
  const index = clamp(Number(missCount) || 0, 0, levels.length - 1);
  return levels[index];
};

export const distanceKmToAccuracyPct = (distanceKm) => {
  const d = Math.max(0, Number(distanceKm) || 0);
  const raw = 100 * Math.exp(-d / EARTH_ACCURACY_DECAY_KM);
  return clamp(Math.round(raw), 0, 100);
};

export const isEarthGuessCorrect = (distanceKm) =>
  Number.isFinite(distanceKm) && distanceKm <= EARTH_CORRECT_DISTANCE_KM;
